import { DiscountTypes, Expense, FullDiscountFragment, PriceType, SelectedProduct, Tax } from "graphql.generated";


import { EditableExpense } from "../mutate-charges/mutate-charges.state";

import { WorkorderEventAttachment } from './job-workorders.interfaces';

export interface EditableCharge {
  amount: number;
  quantity: number;
  chargeId: string;
  productId?: string;
  priceId?: string;
  productName?: string;
  description?: string;
  priceType?: PriceType,
  expenses: EditableExpense[];
  new: boolean;
  modified: boolean;
  removed: boolean;
  taxes: {
    id: string;
    percentage: number;
  }[];
  attributes?: string[];
}

export interface EditableDiscount {
  name: string;
  code: string;
  appliedId: string;
  discountId?: string;
  customAmount?: number;
  discountType?: DiscountTypes;
  new: boolean;
  removed: boolean;
}

export interface EditableWorkorder {
  eventId: string;
  title: string;
  type: string;
  charges: EditableCharge[],
  discounts: EditableDiscount[],
  eventNotes: string;
  /** Files attached to THE event via the Event Notes 📎 (#6983) —
   *  undefined until touched; the full authoritative list once edited. */
  eventAttachments?: WorkorderEventAttachment[];
  new: boolean;
  modified: boolean;
  removed: boolean;
  cancelled: boolean;
}

export const jobWorkordersInitialState = {
  /** The job the editor currently holds — jobLoaded for a DIFFERENT job is
   *  the only transition that may drop the upload guard (see reducer). */
  loadedJobId: undefined as undefined | string,
  workordersEditor: {
    workorders: [] as EditableWorkorder[],
    /** Per-event in-flight File-upload refcounts. Saves wait on this: a save
     * that snapshots eventAttachments mid-upload would lose the file. */
    eventUploads: {} as Record<string, number>,
    collapsed: {} as Record<string, boolean>,
    confidentialInfoExpanded: {} as Record<string, boolean>,
    actionsMenuEventId: undefined as undefined | string,
    actionsMenuChargeId: undefined as undefined | string,
    actionsMenuAppliedDiscountId: undefined as undefined | string,
  },
  addChargesDialog: {
    selectedEventId: undefined as undefined | string,
    selectedProducts: {} as Record<string, number>,
    productSearch: '' as string,
  },
  availableDiscounts: [] as FullDiscountFragment[],
  taxes: [] as Tax[],
  expenses: [] as Expense[],
  selectedProducts: [] as SelectedProduct[],

} as const;

export type JobWorkordersState = typeof jobWorkordersInitialState;
